import {
	defaultNotesFormState,
	defaultPeopleFormState,
	defaultRecipientsFormState,
	defaultSiteFormState,
	isLocked,
} from "features/forms";

import {
	defaultSaveState,
	saveRequested,
	saveFailed,
	saveSuccess,
} from "utils";

import * as fromActions from "../actions/types";

export const defaultState = {
	...defaultSaveState,
	...defaultNotesFormState,
	...defaultPeopleFormState,
	...defaultRecipientsFormState,
	...defaultSiteFormState,
	title: "",
	siteId: "00000000-0000-0000-0000-000000000000",
	locked: false,
};

const reducer = (state = defaultState, action) => {
	switch (action.type) {
		case fromActions.ADD_SAFETY_MINUTES_FORM_RESET: {
			return defaultState;
		}
		case fromActions.ADD_SAFETY_MINUTES_FORM_VALUE_CHANGE:
			return isLocked({
				...state,
				...action.payload,
			});
		case fromActions.ADD_SAFETY_MINUTES_FORM_SUBMIT:
			return isLocked(saveRequested(state));
		case fromActions.ADD_SAFETY_MINUTES_FORM_SUBMIT_FAILED:
			return isLocked(saveFailed(state, action.payload));
		case fromActions.ADD_SAFETY_MINUTES_FORM_SUBMIT_SUCCESS:
			return isLocked(saveSuccess(state));
		default:
			return isLocked(state);
	}
};

export default reducer;
